/**
 * The state of a Boolean branch setting in the branch-scoped settings map: true for 'true', false for any other
 * value, and undefined when the key is missing. The server always sends resolved values, so a missing key means the
 * settings have not loaded yet. Callers that gate something on the setting treat undefined as off (fail-closed), but
 * callers that also act on an explicit off (stopping, discarding) can tell "not loaded" from "off".
 *
 * @param settings The branch-scoped settings map from the ApplicationContextStore.
 * @param key The setting key (a SettingKey enum member name).
 * @returns true, false, or undefined when the key is not in the map.
 */
export function settingState(settings: Record<string, string>, key: string): boolean | undefined {
    const value = settings[key];
    return value === undefined ? undefined : value === 'true';
}
